import React from 'react'
import { Icon, List, Popup } from 'semantic-ui-react'
import PropTypes from "prop-types";
import { useTextResources } from '../../language';
import moment from 'moment';
import { dateTimeFormat } from '../../components/shared/constants';
import { GetFullName } from '../../components/shared/utils';

const DayUsePopup = ({ event, open, context, onClose, onEventClick }) => {
    const text = useTextResources();
    const events = event ? event.extendedProps?.events || [] : [];

    const count = event?.extendedProps?.groupCount || events.length;

    return event ? (
        <Popup hoverable open={open} context={context} position="top center" wide>
            <Popup.Header>
                {count} {text('Reservations')}
                <Icon name="close" onClick={onClose} style={{ float: "right", cursor: "pointer" }} />
            </Popup.Header>
            <Popup.Content>
                <List relaxed selection>
                    {events.map(reservation => {
                        const guestName = GetFullName(reservation.Guest);
                        const checkIn = moment(reservation.CheckInDate).format(dateTimeFormat);
                        const checkOut = moment(reservation.CheckOutDate).format(dateTimeFormat);
                        const roomName = reservation.Room?.Number || reservation.RoomId;

                        return (
                            <List.Item
                                key={reservation.Id}
                                onClick={() => {
                                    onEventClick(reservation);
                                    onClose();
                                }}
                            >
                                <List.Icon name="circle" />
                                <List.Content>
                                    <List.Header>{guestName}</List.Header>
                                    <List.Description>
                                        {checkIn} - {checkOut}
                                    </List.Description>
                                </List.Content>
                                <List.Content>
                                    {text("Room")}: {roomName}
                                </List.Content>
                            </List.Item>
                        );
                    })}
                </List>
            </Popup.Content>
        </Popup>
    ) : null;
};

DayUsePopup.propTypes = {
    event: PropTypes.object,
    open: PropTypes.bool,
    context: PropTypes.any,
    onClose: PropTypes.func,
    onEventClick: PropTypes.func,
};

export default DayUsePopup;
